import React, { useContext, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { LoginContext } from '../../../home/logincontext';
import { GlobalContext } from '../../context/provider';
import numberbeautifuly from '../../../utils/numberbeautify';

const Expense_report_detail_modal = props => {
    const { reportState, reportDispatch } = useContext(GlobalContext);
    return (
        <div dir="rtl">
            <Modal
                show={props.show}
                onHide={() => props.setshow(false)}
                dialogClassName="modal-100w"
                aria-labelledby="example-custom-modal-styling-title"
                size="lg"
            >
                <Modal.Body>
                    <Row className="justify-content-md-center mt-4" dir='rtl'>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>ناوی کەس و مەبەستی خەرجی</th>
                                    <th>بڕ</th>
                                    <th>شوێن و جۆری خەرجی</th>
                                    <th>بەروار</th>
                                    <th>تێبینی</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reportState.expense.map((lis) => (
                                    <tr>
                                        <td>{lis.project_expense_name}</td>
                                        <td>{numberbeautifuly(lis.project_expense_amount)} IQD</td>
                                        <td>{lis.project_expense_type}</td>
                                        <td>{lis.project_expense_date}</td>
                                        <td>{lis.project_expense_note}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td>کۆی گشتی</td>
                                    <td colSpan={4} style={{ textAlign: 'center' }}>{numberbeautifuly(reportState.total_expense)} IQD</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={() => {
                        props.setshow(false);
                        props.setreporttype('expense');
                        props.printit();
                    }}>
                        پرینت
                    </Button>
                    <Button variant="primary" onClick={() => {
                        props.setshow(false);
                    }}>
                        داخستن
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Expense_report_detail_modal